var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreenRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1088C0 10.6181 0.49 11.0312 1.09462 11.0312H16.2231L13.7038 13.1388C13.2746 13.5096 13.2846 14.1035 13.7254 14.465C13.9518 14.6402 14.2308 14.7338 14.5171 14.7304C14.8033 14.727 15.0801 14.627 15.3023 14.4465L19.6823 10.7619C19.7796 10.6781 19.858 10.5745 19.9123 10.4581C20.0292 10.235 20.0292 9.98115 19.9123 9.75808C19.86 9.64577 19.7815 9.54269 19.6815 9.45423L15.3031 5.77115C14.8738 5.40962 14.1777 5.40962 13.7485 5.77115C13.648 5.84798 13.5666 5.94694 13.5105 6.06033C13.4545 6.17373 13.4253 6.29851 13.4253 6.425C13.4253 6.55149 13.4545 6.67627 13.5105 6.78967C13.5666 6.90306 13.648 7.00202 13.7485 7.07885L16.2231 9.18808H1.09462C0.49 9.18808 0 9.60038 0 10.1088Z",
    fill: "#40C706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreenRight);
export default __webpack_public_path__ + "static/media/arrow-green-right.9b61d9bf2140d813868879d60d62b91a.svg";
export { ForwardRef as ReactComponent };